import Vue from 'vue'
import VueRouter from 'vue-router'
import MainContainer from '@/components/MainContainer'
import Home from '@/views/Home'
import Dashboard from '@/views/Dashboard'
import Impressum from '@/views/Impressum'
import Datenschutz from '@/views/Datenschutz'
import Login from '@/views/Login'
import Register from '@/views/Register'
// import ForgotPassword from '@/views/ForgotPassword'
import Orders from '@/views/Orders'
import Restaurants from '@/views/Restaurants'
import Menu from '@/views/Menus'
import Statistics from '@/views/Statistics'
import Settings from '@/views/Settings'
import Bestellung from '@/views/Bestellung'
import Kiosk from '@/views/Kiosk'
import Resetpassword from '@/views/Resetpassword'
import InHouse from '@/views/InHouse'
import Overview from '@/views/Overview'
Vue.use(VueRouter)

  const routes = [
    {
      path: '/overview1337',
      name: 'Overview',
      component: Overview,
    },
    {
      path: '/kiosk',
      name: 'Kiosk',
      component: Kiosk,
    },
    {
      path: '/',
      name: 'Home',
      component: MainContainer,
      children: [
        {
          path: '/',
          name: 'Home',
          component: Home
        },
        {
          path: '/me',
          name: 'Einstellungen',
          component: Settings
        },
        {
          path: '/resetpassword',
          name: 'Resetpassword',
          component: Resetpassword
        },
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/login',
          name: 'Login',
          component: Login
        },
        {
          path: '/register',
          name: 'Registrieren',
          component: Register
        },
        // {
        //   path: '/resetpassword',
        //   name: 'ForgotPassword',
        //   component: ForgotPassword
        // },
        {
          path: '/orders',
          name: 'Bestellungen',
          component: Orders
        },
        {
          path: '/inhouse',
          name: 'InHouse',
          component: InHouse
        },
        {
          path: '/bestellung/:id',
          name: 'Bestellungen',
          component: Bestellung
        },
        {
          path: '/menu',
          name: 'Speisekarte',
          component: Menu
        },
        {
          path: '/statistics',
          name: 'Statistiken',
          component: Statistics
        },
        {
          path: '/restaurants',
          name: 'Restaurants',
          component: Restaurants
        },
        {
          path: 'impressum',
          name: 'Impressum',
          component: Impressum
        },
        {
          path: 'datenschutz',
          name: 'Datenschutz',
          component: Datenschutz
        },
      ]
    },
    
  {
    path: '*', 
    beforeEnter: (to, from, next) => {
      next('/dashboard')
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
